<script lang="ts">
  let {
    text = undefined,
    entryCount = 0,
    offsetX = undefined,
  }: { text?: string; entryCount: number; offsetX?: string } = $props();
</script>

<oc-skip-link-v1 style:--oc-skip-link-v1-offset-x={offsetX}>
  <oc-button-v1
    variant="secondary"
    size={/*      */ "50"}
    icon-type-left="skip-link"
    oc-aria-label={text
      ? `Es folgt eine Liste mit ${entryCount} Einträgen. ${text} überspringen`
      : `Es folgt eine Liste mit ${entryCount} Einträgen. Überspringen`}
  >
    {text ? `${text} überspringen` : "Überspringen"}
  </oc-button-v1>
</oc-skip-link-v1>

<style>
  oc-skip-link-v1:not(:defined) {
    display: none;
  }
</style>
